/*
 * This file is part of glowingblue/orell-facade.
 *
 * Copyright (c) 2022 Glowing Blue AG.
 * Authors: Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import Button from 'flarum/common/components/Button';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import icon from 'flarum/common/helpers/icon';
import Stream from 'flarum/common/utils/Stream';
import app from 'flarum/forum/app';
import { slug } from '../../../../common';
import AbstractInput from './AbstractInput';

const t = app.translator.trans.bind(app.translator);
const prfx = `${slug}.forum.banner_form.inputs.labels.upload`;

export default class ImageUpload extends AbstractInput {
	oninit(vnode) {
		super.oninit(vnode);

		this.loading = new Stream(false);
		this.uploadError = new Stream('');
	}

	className() {
		return `${super.className()} ${super.className()}--image-upload`;
	}

	content() {
		const { name, device } = this.attrs;

		return [
			<div className="FormControl">
				<div className="Button hasIcon">
					{this.loading() ? (
						<LoadingIndicator className="Button-icon" display="inline" size="small" />
					) : (
						icon('far fa-image', { className: 'Button-icon' })
					)}
					<span className="Button-label">{this.loading() ? t(`${prfx}.loading`) : this.value() ? t(`${prfx}.change`) : t(`${prfx}.attach`)}</span>
					<form id={`gb-image-upload-form-${name}-${device}`}>
						<input type="file" accept="image/*" onchange={(event) => this.processUpload(event)} disabled={this.loading()}></input>
					</form>
				</div>
				{this.uploadError() && <div className="BannerForm--uploadError">{this.uploadError()}</div>}
				{this.value() && [
					<Button className="Button hasIcon" icon="far fa-trash" onclick={() => this.value(null)}>
						{t(`${prfx}.remove`)}
					</Button>,
					<div className="BannerForm--image">{<img src={this.value()} />}</div>,
				]}
			</div>,
		];
	}

	/**
	 * Process the upload event.
	 *
	 * @param event
	 */
	processUpload(event) {
		// Get the file from the input field
		var file = $(event.target)[0].files[0];

		this.loading(true);

		this.uploadFile(file).then(
			(response) => this.success(response),
			(message) => this.failure(message)
		);
	}

	uploadFile(file) {
		const data = new FormData();

		data.append('image', file);
		// send a POST request to the api
		return app.request({
			method: 'POST',
			url: app.forum.attribute('apiUrl') + '/gb_of_facade_image_upload',
			// prevent JSON.stringifying the form data in the XHR call
			serialize: (raw) => raw,
			body: data,
		});
	}

	/**
	 * Handles upload errors.
	 *
	 * @param message
	 */
	failure(message) {
		if (message.status === 413) {
			this.uploadError(t(`${prfx}.error.file_too_big`));
		} else {
			this.uploadError(t(`${prfx}.error.upload_error`));
		}
		this.loading(false);
		m.redraw();
	}

	/**
	 * Upload, Appends the file's link to the body of the composer.
	 *
	 * @param response
	 */
	success(response) {
		if (response.error || !response.imageUrl) {
			this.uploadError(response.error || '');
			this.loading(false);
			return;
		}
		this.uploadError(undefined);
		this.value(response.imageUrl);
		this.loading(false);
		m.redraw();
	}
}
